import React from 'react';
import { connect } from 'react-redux';
import DefaultPaymentInfoItem from './DefaultPaymentInfoItem';
import { setAccountPanel } from '../../actions/panels';
import { ModalCloseButton } from '../common/ModalCloseButton';
import LoadingSpinner from '../common/LoadingSpinner';

class PaymentInformation extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        if ( this.props.loading ) {
            return (
                <LoadingSpinner />
            )
        }

        return (
            <div className="update-profile">
                <div className="text-padding">
                <div className="close-button">
                        <ModalCloseButton 
                            clickAction={() => this.props.dispatch(setAccountPanel('info'))} 
                        />
                    </div>
                    <div>
                        <h2 className="heading in-item address-card">Select Payment Method</h2>
                    </div>

                    {(this.props.user.paymentInfo.length <= 0) && (
                        <p className="noCardText">No credit cards saved to your account. Add cards by saving your payment info when ordering your eats!</p>
                    )}

                    <div className="bottomMargin">
                        { this.props.user.paymentInfo.map((card) => (
                            <DefaultPaymentInfoItem card={card} />
                        ))}
                    </div>
               
                 </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token,
        loading: state.auth.loading
    };
};

export default connect(mapStateToProps)(PaymentInformation);